(() => {
  const DATA = window.CanteinAminoData;
  const app = document.querySelector('[data-aa-app]');
  if (!DATA || !app) return;

  const $ = (selector) => app.querySelector(selector);
  const form = $('[data-aa-form]');
  const logEl = $('[data-aa-log]');
  const outputEl = $('[data-aa-output]');
  const summaryEl = $('[data-aa-summary]');
  const searchEl = $('#aa-food-search');
  const optionsEl = $('#aa-food-options');
  const mealNameEl = $('[data-aa-meal-name]');
  const waistLabelEl = $('[data-aa-waist-label]');
  const navyResultEl = $('[data-aa-navy-result]');
  const navyApplyEl = $('[data-aa-navy-apply]');

  const ANALYTICS_KEY = app.dataset.analyticsKey || '';
  const ANALYTICS_HOST = (app.dataset.analyticsHost || 'https://us.i.posthog.com').replace(/\/+$/, '');
  const VISIT_ID = window.crypto?.randomUUID?.() || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  const MISS_DELAY = 2000;
  const STORAGE_KEY = 'cantein-amino-calculator-v1';
  const KG_PER_LB = 0.45359237;
  const CM_PER_IN = 2.54;
  const METER_MAX = 1.25;
  const MET = 0.995;
  const INDEX = Object.fromEntries(DATA.aminos.map((key, i) => [key, i]));
  const FOODS = DATA.foods;
  const FOOD = Object.fromEntries(FOODS.map((food) => [food.id, food]));

  // req: WHO/FAO/UNU 2007 requirement in mg/kg/day. pattern: adult scoring pattern in mg/g protein.
  const EAA = [
    { key: 'his', name: 'Histidine', req: 10, pattern: 15, parts: ['his'] },
    { key: 'ile', name: 'Isoleucine', req: 20, pattern: 30, parts: ['ile'] },
    { key: 'leu', name: 'Leucine', req: 39, pattern: 59, parts: ['leu'] },
    { key: 'lys', name: 'Lysine', req: 30, pattern: 45, parts: ['lys'] },
    { key: 'saa', name: 'Methionine + cysteine', req: 15, pattern: 22, parts: ['met', 'cys'] },
    { key: 'aaa', name: 'Phenylalanine + tyrosine', req: 25, pattern: 38, parts: ['phe', 'tyr'] },
    { key: 'thr', name: 'Threonine', req: 15, pattern: 23, parts: ['thr'] },
    { key: 'trp', name: 'Tryptophan', req: 4, pattern: 6, parts: ['trp'] },
    { key: 'val', name: 'Valine', req: 26, pattern: 39, parts: ['val'] },
  ];
  // Protein in g/kg of reference weight.
  const ACTIVITY = {
    sedentary: { factor: 1.2, low: 1.2, high: 1.6, lifting: false },
    active: { factor: 1.4, low: 1.4, high: 2.0, lifting: false },
    strength: { factor: 1.6, low: 1.6, high: 2.2, lifting: true },
    cut: { factor: 2.2, low: 2.0, high: 2.6, lifting: true },
  };
  const DIETS = { vegan: 0, vegetarian: 1, pescatarian: 2, omnivore: 3 };
  const DIET_FOODS = { vegan: 'vegan', vegetarian: 'vegetarian', pescatarian: 'pescatarian', omnivore: 'any' };
  const MEALS = { breakfast: 'Breakfast', lunch: 'Lunch', dinner: 'Dinner', snacks: 'Snacks' };
  const MAIN_MEALS = ['breakfast', 'lunch', 'dinner'];
  const REFERENCE_FAT = { male: 15, female: 25 };
  const ACE = {
    male: [[6, 'essential fat'], [14, 'athlete'], [18, 'fitness'], [25, 'average'], [Infinity, 'obese']],
    female: [[14, 'essential fat'], [21, 'athlete'], [25, 'fitness'], [32, 'average'], [Infinity, 'obese']],
  };
  const CHOICES = {
    units: ['imperial', 'metric'],
    sex: ['male', 'female'],
    activity: Object.keys(ACTIVITY),
    diet: Object.keys(DIETS),
    meal: Object.keys(MEALS),
  };
  const FIELDS = ['units', 'sex', 'age', 'weight', 'bodyFat', 'activity', 'diet', 'heightFt', 'heightIn', 'heightCm', 'neck', 'waist', 'hip', 'meal'];
  const LENGTH_FIELDS = ['neck', 'waist', 'hip'];
  const NAVY_FIELDS = ['sex', 'heightFt', 'heightIn', 'heightCm', 'neck', 'waist', 'hip'];
  const ITEM_FIELDS = ['qty', 'unit', 'protein', 'profile'];
  const DEFAULTS = {
    units: 'imperial', sex: 'male', age: '', weight: '', bodyFat: '', activity: 'active', diet: 'omnivore',
    heightFt: '', heightIn: '', heightCm: '', neck: '', waist: '', hip: '', meal: 'breakfast',
  };
  const PLACEHOLDERS = {
    imperial: { weight: '170', neck: '15.5', waist: '34', hip: '40' },
    metric: { weight: '77', neck: '39', waist: '86', hip: '102' },
  };
  const SAMPLES = {
    vegan: {
      profile: { sex: 'male', age: '38', weightLb: 176, bodyFat: '18', activity: 'strength' },
      diet: 'vegan',
      items: [
        ['oats', 0.5, 'breakfast'], ['soy-milk', 1, 'breakfast'], ['blueberries', 1, 'breakfast'], ['chia', 0.5, 'breakfast'],
        ['lentils', 1, 'lunch'], ['quinoa', 1, 'lunch'], ['broccoli', 1, 'lunch'], ['pumpkin-seeds', 1, 'lunch'],
        ['tofu', 5, 'dinner'], ['brown-rice', 1, 'dinner'], ['spinach', 2, 'dinner'], ['avocado', 0.5, 'dinner'],
        ['almonds', 1, 'snacks'], ['apple', 1, 'snacks'],
      ],
    },
    omnivore: {
      profile: { sex: 'female', age: '44', weightLb: 150, bodyFat: '27', activity: 'active' },
      diet: 'omnivore',
      items: [
        ['egg', 2, 'breakfast'], ['bread-whole-grain', 2, 'breakfast'], ['avocado', 0.5, 'breakfast'],
        ['chicken-breast', 4, 'lunch'], ['white-rice', 1, 'lunch'], ['broccoli', 1, 'lunch'],
        ['salmon', 5, 'dinner'], ['potato', 1, 'dinner'], ['green-beans', 1, 'dinner'],
        ['greek-yogurt', 1, 'snacks'], ['banana', 1, 'snacks'],
      ],
    },
  };

  let state = loadState();
  let nextUid = state.items.length + 1;
  let options = [];
  let activeOption = -1;
  let navyEstimate = {};
  let saveTimer = 0;

  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => `&#${char.charCodeAt(0)};`);
  const num = (value) => {
    const n = parseFloat(String(value ?? '').replace(',', '.'));
    return Number.isFinite(n) ? n : NaN;
  };
  const round = (value, digits = 0) => Math.round(value * 10 ** digits) / 10 ** digits;
  const fmtNum = (value, digits = 0) => round(value, digits).toLocaleString('en-US', { maximumFractionDigits: digits });
  const fmtAmino = (mg) => (mg / 1000).toFixed(mg < 995 ? 2 : 1);
  const fmtProtein = (grams) => (grams < 9.95 ? grams.toFixed(1) : fmtNum(grams));
  const fmtPct = (ratio) => `${Math.round(ratio * 100)}%`;
  const fmtWeight = (kg) => (state.units === 'metric' ? `${fmtNum(kg, 1)} kg` : `${fmtNum(kg / KG_PER_LB)} lb`);
  const lower = (text) => text.charAt(0).toLowerCase() + text.slice(1);
  const listJoin = (items) => (items.length < 3 ? items.join(' and ') : `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`);
  const FRACTIONS = { 0.25: '¼', 0.5: '½', 0.75: '¾' };

  function fmtQty(qty) {
    const whole = Math.floor(qty + 1e-6);
    const part = round(qty - whole, 2);
    if (part === 0) return String(whole);
    if (FRACTIONS[part]) return `${whole || ''}${FRACTIONS[part]}`;
    return fmtNum(qty, 2);
  }

  const servingLabel = (label, grams) => (/\d/.test(label) ? label : `${label} (${fmtNum(grams)} g)`);

  function amountLabel(food, { qty, unit }) {
    if (unit === 'g') return `${fmtNum(qty, 1)} g`;
    const [label, size, plural] = food.s[unit];
    const name = (qty > 1 + 1e-6 ? plural || label : label).replace(/\s*\(.*\)$/, '');
    return `${fmtQty(qty)} ${name} (${fmtNum(qty * size)} g)`;
  }

  const portion = (food, grams) => amountLabel(food, { qty: grams / food.s[0][1], unit: 0 });

  // mg of an amino acid (or pair) per gram of food.
  const supply = (food, aa) => aa.parts.reduce((sum, key) => sum + food.a[INDEX[key]], 0) / 100;

  function loadState() {
    const fresh = { ...DEFAULTS, items: [] };
    try {
      const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      if (!saved || typeof saved !== 'object') return fresh;
      for (const field of FIELDS) {
        if (typeof saved[field] !== 'string') continue;
        if (CHOICES[field] && !CHOICES[field].includes(saved[field])) continue;
        fresh[field] = saved[field];
      }
      const items = Array.isArray(saved.items) ? saved.items.filter(isValidItem) : [];
      fresh.items = items.map((item, i) => ({ ...item, uid: i + 1 }));
    } catch {
      return fresh;
    }
    return fresh;
  }

  function isValidItem(item) {
    if (!item || !MEALS[item.meal]) return false;
    if (item.custom) return typeof item.name === 'string';
    const food = FOOD[item.foodId];
    return Boolean(food) && (item.unit === 'g' || (Number.isInteger(item.unit) && item.unit >= 0 && item.unit < food.s.length));
  }

  function save() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(() => {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch {
        // Storage can be unavailable (private browsing); the calculator still works for this visit.
      }
    }, 250);
  }

  function getProfile() {
    const age = num(state.age);
    const weightInput = num(state.weight);
    if (!(age > 0) || !(weightInput > 0)) {
      return { error: 'Enter your age and weight to see your protein and amino acid targets.' };
    }
    if (age < 18) return { error: 'This calculator is designed for adults 18 and older.' };
    if (age > 110) return { error: 'Check your age.' };
    const weight = state.units === 'metric' ? weightInput : weightInput * KG_PER_LB;
    if (weight < 30 || weight > 300) {
      return { error: `Check your weight. It should be between ${state.units === 'metric' ? '30 and 300 kg' : '66 and 660 lb'}.` };
    }
    const sex = state.sex === 'female' ? 'female' : 'male';
    const bodyFatInput = num(state.bodyFat);
    const bodyFat = bodyFatInput >= 3 && bodyFatInput <= 70 ? bodyFatInput : null;
    const leanMass = bodyFat === null ? null : weight * (1 - bodyFat / 100);
    const referenceFat = REFERENCE_FAT[sex];
    const refWeight = bodyFat !== null && bodyFat > referenceFat ? leanMass / (1 - referenceFat / 100) : weight;
    const activity = ACTIVITY[state.activity] || ACTIVITY.active;
    const older = age >= 65;
    const target = activity.factor * refWeight;
    return {
      sex,
      weight,
      bodyFat,
      bodyFatIgnored: String(state.bodyFat).trim() !== '' && bodyFat === null,
      leanMass,
      refWeight,
      referenceFat,
      activity,
      older,
      target,
      low: activity.low * refWeight,
      high: activity.high * refWeight,
      rda: 0.8 * refWeight,
      proteinTolerance: Math.max(2, target * 0.02),
      mealProtein: (older || activity.lifting ? 0.4 : 0.3) * refWeight,
      mealLeucine: older ? 3000 : 2500,
      aminos: EAA.map((aa) => ({ ...aa, optimal: aa.pattern * target, minimum: aa.req * refWeight })),
    };
  }

  function customProfile(kind) {
    const { animal, plant } = DATA.profiles;
    if (kind === 'animal') return animal;
    if (kind === 'plant') return plant;
    return animal.map((value, i) => (value + plant[i]) / 2);
  }

  function itemGrams(item, food) {
    const qty = Math.max(0, num(item.qty) || 0);
    return item.unit === 'g' ? qty : qty * food.s[item.unit][1];
  }

  function nutrients(item) {
    if (item.custom) {
      const protein = Math.max(0, num(item.protein) || 0);
      return { protein, kcal: null, aminos: customProfile(item.profile).map((perGram) => perGram * protein) };
    }
    const food = FOOD[item.foodId];
    const factor = itemGrams(item, food) / 100;
    return { protein: food.p * factor, kcal: food.k * factor, aminos: food.a.map((mg) => mg * factor) };
  }

  function analyze(profile) {
    const zeros = () => DATA.aminos.map(() => 0);
    const totals = { protein: 0, aminos: zeros() };
    const meals = Object.fromEntries(Object.keys(MEALS).map((key) => [key, { protein: 0, aminos: zeros(), count: 0 }]));
    for (const item of state.items) {
      const n = nutrients(item);
      const meal = meals[item.meal];
      totals.protein += n.protein;
      meal.protein += n.protein;
      meal.count += 1;
      n.aminos.forEach((mg, i) => {
        totals.aminos[i] += mg;
        meal.aminos[i] += mg;
      });
    }
    const eaa = profile.aminos.map((aa) => {
      const intake = aa.parts.reduce((sum, key) => sum + totals.aminos[INDEX[key]], 0);
      const ratio = intake / aa.optimal;
      let status = 'low';
      if (ratio >= MET) status = 'ok';
      else if (intake >= aa.minimum) status = 'short';
      return { ...aa, intake, ratio, status, deficit: Math.max(0, aa.optimal - intake) };
    });
    const proteinDeficit = Math.max(0, profile.target - totals.protein);
    let proteinStatus = 'low';
    if (proteinDeficit <= profile.proteinTolerance) proteinStatus = 'ok';
    else if (totals.protein >= profile.rda) proteinStatus = 'short';
    return {
      totals,
      meals,
      eaa,
      gaps: eaa.filter((aa) => aa.status !== 'ok').sort((a, b) => a.ratio - b.ratio),
      proteinRatio: totals.protein / profile.target,
      proteinDeficit,
      proteinStatus,
    };
  }

  function candidates() {
    const level = DIETS[state.diet] ?? DIETS.omnivore;
    return FOODS.filter((food) => food.x > 0 && food.d <= level);
  }

  // Greedy: each round adds the food and portion that closes the most remaining gap per calorie.
  function buildPlan(profile, analysis) {
    const pool = candidates();
    const remaining = analysis.eaa.map((aa) => aa.deficit);
    let proteinLeft = analysis.proteinDeficit;
    const complete = () => proteinLeft <= profile.proteinTolerance
      && remaining.every((mg, i) => mg <= analysis.eaa[i].optimal * (1 - MET));
    const picks = [];
    while (picks.length < 3 && !complete()) {
      let best = null;
      for (const food of pool) {
        if (picks.some((pick) => pick.food === food)) continue;
        const step = food.s[0][1] * food.r;
        for (let grams = step; grams <= food.x + 0.01; grams += step) {
          const protein = (food.p * grams) / 100;
          let coverage = (2 * Math.min(proteinLeft, protein)) / profile.target;
          analysis.eaa.forEach((aa, i) => {
            if (remaining[i] > 0) coverage += Math.min(remaining[i], supply(food, aa) * grams) / aa.optimal;
          });
          if (coverage <= 0) continue;
          const kcal = (food.k * grams) / 100;
          const score = coverage / (kcal + 150);
          if (!best || score > best.score) best = { food, grams, kcal, protein, score };
        }
      }
      if (!best) break;
      picks.push(best);
      analysis.eaa.forEach((aa, i) => {
        remaining[i] = Math.max(0, remaining[i] - supply(best.food, aa) * best.grams);
      });
      proteinLeft = Math.max(0, proteinLeft - best.protein);
    }
    return { picks, remaining, complete: complete() };
  }

  function topFoods(gap) {
    const rows = candidates()
      .filter((food) => supply(food, gap) > 0)
      .map((food) => {
        const perGram = supply(food, gap);
        const step = food.s[0][1] * food.r;
        const maxGrams = Math.floor(food.x / step + 1e-6) * step;
        const needed = Math.max(step, Math.ceil(gap.deficit / perGram / step - 1e-6) * step);
        const grams = Math.min(needed, maxGrams);
        return {
          food,
          grams,
          closes: needed <= maxGrams + 1e-6,
          covered: Math.min(1, (perGram * grams) / gap.deficit),
          density: (perGram * 100) / food.k,
          kcal: (food.k * grams) / 100,
          protein: (food.p * grams) / 100,
        };
      });
    rows.sort((a, b) => Number(b.closes) - Number(a.closes) || b.density - a.density);
    const perGroup = {};
    return rows
      .filter(({ food }) => {
        perGroup[food.g] = (perGroup[food.g] || 0) + 1;
        return perGroup[food.g] <= 2;
      })
      .slice(0, 6);
  }

  function meter(ratio, status, label, minimumRatio) {
    const at = (value) => `${((Math.min(value, METER_MAX) / METER_MAX) * 100).toFixed(1)}%`;
    const minimum = minimumRatio ? `<span class="cantein-aa__meter-mark is-min" style="--at: ${at(minimumRatio)}"></span>` : '';
    return `<div class="cantein-aa__meter" role="img" aria-label="${esc(label)}">`
      + `<span class="cantein-aa__meter-fill is-${status}" style="--fill: ${at(ratio)}"></span>`
      + `${minimum}<span class="cantein-aa__meter-mark" style="--at: ${at(1)}"></span></div>`;
  }

  const panel = (title, body, className = '') => `<div class="cantein-aa__panel${className ? ` ${className}` : ''}"><h3>${title}</h3>${body}</div>`;

  function addButton(food, grams, className) {
    const label = `Add ${portion(food, grams)} of ${food.n} to ${MEALS[state.meal].toLowerCase()}`;
    return `<button type="button" class="${className}" data-add-food="${esc(food.id)}" data-grams="${round(grams, 2)}" aria-label="${esc(label)}">Add</button>`;
  }

  function proteinPanel(profile, analysis) {
    const { factor } = profile.activity;
    const factorText = state.units === 'metric' ? `${factor} g/kg` : `${factor} g/kg (${(factor * KG_PER_LB).toFixed(2)} g/lb)`;
    let basis;
    if (profile.bodyFatIgnored) {
      basis = `${factorText} × ${fmtWeight(profile.weight)} body weight. Body fat is only used between 3% and 70%, so no lean-mass adjustment was applied.`;
    } else if (profile.bodyFat === null) {
      basis = `${factorText} × ${fmtWeight(profile.weight)} body weight. Add your body fat for a lean-mass adjustment.`;
    } else if (profile.refWeight < profile.weight) {
      basis = `${factorText} × ${fmtWeight(profile.refWeight)}: your weight at ${profile.referenceFat}% body fat with your current lean mass of ${fmtWeight(profile.leanMass)}.`;
    } else {
      basis = `${factorText} × ${fmtWeight(profile.weight)}. At ${fmtNum(profile.bodyFat, 1)}% body fat, no lean-mass adjustment is needed.`;
    }
    if (state.items.length) {
      basis += analysis.proteinStatus === 'ok' ? ' Target met today.' : ` You’re ${fmtProtein(analysis.proteinDeficit)} g short today.`;
    }
    const eaten = analysis.totals.protein;
    const label = `${fmtNum(eaten)} of ${fmtNum(profile.target)} grams of protein, ${fmtPct(analysis.proteinRatio)} of target`;
    return panel('Daily protein target', `
      <div class="cantein-aa__protein-top">
        <p class="cantein-aa__big">${fmtNum(profile.target)}<small>g / day</small></p>
        <dl class="cantein-aa__stats">
          <dt>Eaten today</dt><dd>${fmtNum(eaten)} g</dd>
          <dt>Healthy range</dt><dd>${fmtNum(profile.low)}–${fmtNum(profile.high)} g</dd>
          <dt>RDA minimum</dt><dd>${fmtNum(profile.rda)} g</dd>
        </dl>
      </div>
      ${meter(analysis.proteinRatio, analysis.proteinStatus, label, profile.rda / profile.target)}
      <p class="cantein-aa__panel-note">${esc(basis)}</p>`, 'cantein-aa__protein');
  }

  const STATUS_ICONS = { ok: '✓', short: '↓', low: '!' };
  const statusIcon = (status) => `<em class="cantein-aa__status is-${status}" aria-hidden="true">${STATUS_ICONS[status]}</em>`;

  function aminoPanel(profile, analysis) {
    const bars = analysis.eaa.map((aa) => {
      const label = `${aa.name}: ${fmtAmino(aa.intake)} of ${fmtAmino(aa.optimal)} grams, ${fmtPct(aa.ratio)} of optimal. WHO minimum ${fmtAmino(aa.minimum)} grams.`;
      return `<li class="cantein-aa__bar">
        <span class="cantein-aa__bar-name">${aa.name}</span>
        ${meter(aa.ratio, aa.status, label, aa.minimum / aa.optimal)}
        <span class="cantein-aa__bar-value"><b class="is-${aa.status}">${statusIcon(aa.status)}${fmtPct(aa.ratio)}</b><span>${fmtAmino(aa.intake)} / ${fmtAmino(aa.optimal)} g</span></span>
      </li>`;
    }).join('');
    return panel('Essential amino acids', `
      <p>Today’s intake against your optimal targets: WHO’s adult amino acid pattern applied to your ${fmtNum(profile.target)} g protein target.</p>
      <ul class="cantein-aa__bars">${bars}</ul>
      <p class="cantein-aa__meter-legend">
        <span class="cantein-aa__legend-key"><i></i>${statusIcon('ok')}Optimal met</span>
        <span class="cantein-aa__legend-key"><i class="is-short"></i>${statusIcon('short')}Below optimal</span>
        <span class="cantein-aa__legend-key"><i class="is-low"></i>${statusIcon('low')}Below WHO minimum</span>
        <span class="cantein-aa__legend-key"><i class="is-line"></i>Optimal target</span>
        <span class="cantein-aa__legend-key"><i class="is-min"></i>WHO minimum</span>
      </p>`);
  }

  function gapsPanel(analysis) {
    if (!analysis.gaps.length) {
      const protein = analysis.proteinStatus === 'ok'
        ? ' You also hit your protein target.'
        : ` Total protein is still ${fmtProtein(analysis.proteinDeficit)} g short.`;
      return panel('Biggest gaps', `<p class="cantein-aa__good">All nine essential amino acids are at or above optimal today.${protein}</p>`);
    }
    const gaps = analysis.gaps.slice(0, 3).map((aa, i) => `
      <li class="cantein-aa__gap is-${aa.status}">
        <span class="cantein-aa__gap-rank">${i + 1}</span>
        <div><strong>${aa.name}</strong><p>${fmtAmino(aa.deficit)} g short · ${fmtPct(aa.ratio)} of optimal</p></div>
        <span class="cantein-aa__gap-status">${aa.status === 'low' ? 'Below minimum' : 'Below optimal'}</span>
      </li>`).join('');
    return panel('Biggest gaps', `<p>Essential amino acids furthest below your optimal target today.</p><ul class="cantein-aa__gaps">${gaps}</ul>`);
  }

  function planPanel(profile, analysis, plan) {
    if (!plan.picks.length) return '';
    const rows = plan.picks.map(({ food, grams, kcal, protein }) => `
      <li>
        <div><strong>${esc(food.n)}</strong><span>${esc(portion(food, grams))} · +${fmtProtein(protein)} g protein · ${fmtNum(kcal)} kcal</span></div>
        ${addButton(food, grams, 'cantein-aa__plan-add')}
      </li>`).join('');
    const proteinAfter = analysis.totals.protein + plan.picks.reduce((sum, pick) => sum + pick.protein, 0);
    const kcal = plan.picks.reduce((sum, pick) => sum + pick.kcal, 0);
    const stillShort = analysis.eaa
      .map((aa, i) => ({ aa, ratio: 1 - plan.remaining[i] / aa.optimal }))
      .filter(({ ratio }) => ratio < MET)
      .map(({ aa, ratio }) => `${lower(aa.name)} (${fmtPct(ratio)})`);
    const aminoText = stillShort.length
      ? `still short on ${listJoin(stillShort)}. Add more of the foods below to finish.`
      : 'every essential amino acid at or above optimal.';
    const intro = `The fewest extra calories we could find to reach your targets, using ${DIET_FOODS[state.diet] || 'any'} foods. Tap Add to log a food to ${MEALS[state.meal].toLowerCase()}.`;
    return panel('Close the gaps', `
      <p>${intro}</p>
      <ol class="cantein-aa__plan">${rows}</ol>
      <p class="cantein-aa__plan-after">With these ${fmtNum(kcal)} kcal: ${fmtNum(proteinAfter)} g protein (${fmtPct(proteinAfter / profile.target)} of target) and ${aminoText}</p>`);
  }

  function foodsPanel(analysis) {
    const gap = analysis.gaps[0];
    if (!gap) return '';
    const name = lower(gap.name);
    const rows = topFoods(gap).map(({ food, grams, closes, covered, kcal, protein }) => `
      <li>
        <div><strong>${esc(food.n)}</strong><span class="cantein-aa__tag${closes ? '' : ' is-partial'}">${closes ? 'Closes gap' : `Covers ${fmtPct(covered)}`}</span></div>
        <span>${esc(portion(food, grams))} · ${fmtNum(kcal)} kcal · +${fmtProtein(protein)} g protein</span>
        ${addButton(food, grams, 'cantein-aa__food-add')}
      </li>`).join('');
    if (!rows) return '';
    return panel(`Best foods for ${name}`, `
      <p>Ranked by ${name} per calorie. Each amount covers your ${fmtAmino(gap.deficit)} g ${name} gap on its own, within a realistic portion.</p>
      <ul class="cantein-aa__foods">${rows}</ul>`);
  }

  function mealsPanel(profile, analysis) {
    if (!MAIN_MEALS.some((key) => analysis.meals[key].count)) return '';
    const check = (ok, text) => `<span class="cantein-aa__check${ok ? ' is-ok' : ''}">${text}<span class="visually-hidden">${ok ? ', meets target' : ', below target'}</span></span>`;
    let hits = 0;
    const rows = MAIN_MEALS.map((key) => {
      const meal = analysis.meals[key];
      if (!meal.count) return `<li><strong>${MEALS[key]}</strong><span class="cantein-aa__panel-note">Nothing logged</span></li>`;
      const leucine = meal.aminos[INDEX.leu];
      const proteinOk = meal.protein >= profile.mealProtein * MET;
      const leucineOk = leucine >= profile.mealLeucine * MET;
      if (proteinOk && leucineOk) hits += 1;
      return `<li><strong>${MEALS[key]}</strong>${check(proteinOk, `${fmtProtein(meal.protein)} g protein`)}${check(leucineOk, `${fmtAmino(leucine)} g leucine`)}</li>`;
    }).join('');
    return panel('Per-meal check', `
      <p>Muscle responds meal by meal. Aim for about ${fmtNum(profile.mealProtein)} g protein and ${fmtNum(profile.mealLeucine / 1000, 1)} g leucine at breakfast, lunch, and dinner.</p>
      <ul class="cantein-aa__meals">${rows}</ul>
      <p class="cantein-aa__panel-note">${hits} of 3 main meals hit both targets.</p>`);
  }

  function glycinePanel(analysis) {
    return panel('Glycine', `
      <p class="cantein-aa__big">${fmtAmino(analysis.totals.aminos[INDEX.gly])}<small>g today</small></p>
      <p>Not essential, and there is no official target. A 2009 analysis estimated that diet plus the body’s own synthesis may fall about 10 g a day short of what collagen turnover uses. Collagen and gelatin are the richest sources.</p>`);
  }

  function canteinPanel(profile, analysis) {
    const food = FOOD['cantein-unflavored'];
    const grams = food.s[0][1];
    const protein = (food.p * grams) / 100;
    const leucine = (food.a[INDEX.leu] * grams) / 100;
    const kcal = (food.k * grams) / 100;
    const closes = analysis.gaps.filter((aa) => supply(food, aa) * grams >= aa.deficit).map((aa) => lower(aa.name));
    const lowMeal = MAIN_MEALS.find((key) => {
      const meal = analysis.meals[key];
      const mealLeucine = meal.aminos[INDEX.leu];
      const threshold = profile.mealLeucine * MET;
      return meal.count && mealLeucine < threshold && mealLeucine + leucine >= threshold;
    });
    const lines = [`${fmtNum(protein)} g protein and ${fmtAmino(leucine)} g leucine for ${fmtNum(kcal)} calories`];
    if (analysis.proteinStatus !== 'ok') {
      lines.push(`${fmtPct(Math.min(1, protein / analysis.proteinDeficit))} of the protein you still need today`);
    }
    if (closes.length) lines.push(`Enough to close your ${listJoin(closes)} gap${closes.length > 1 ? 's' : ''}`);
    if (lowMeal) lines.push(`Enough leucine to lift ${MEALS[lowMeal].toLowerCase()} past the ${fmtNum(profile.mealLeucine / 1000, 1)} g threshold`);
    lines.push('One ingredient: organic hemp protein');
    const lysineOpen = analysis.gaps.some((aa) => aa.key === 'lys') && !closes.includes('lysine');
    const note = lysineOpen
      ? 'Hemp is lowest in lysine, so pair it with lentils, tofu, or edamame to close your lysine gap.'
      : 'Hemp is lowest in lysine; lentils, tofu, or edamame balance it.';
    return panel('Where Cantein fits', `
      <p>One 35 g scoop of Cantein Unflavored adds:</p>
      <ul>${lines.map((line) => `<li>${esc(line)}</li>`).join('')}</ul>
      <p>${note}</p>
      <a href="/products/hemp-protein-unflavored">Shop Cantein Unflavored</a>`, 'cantein-aa__cantein');
  }

  function summaryText(profile, analysis) {
    if (!state.items.length) {
      return `Your target is ${fmtNum(profile.target)} g of protein a day. Log today’s food to find your amino acid gaps.`;
    }
    const protein = `Protein: ${fmtNum(analysis.totals.protein)} of ${fmtNum(profile.target)} g (${fmtPct(analysis.proteinRatio)}).`;
    if (!analysis.gaps.length) return `${protein} Every essential amino acid is at or above optimal.`;
    const top = analysis.gaps[0];
    return `${protein} Biggest gap: ${lower(top.name)} at ${fmtPct(top.ratio)} of optimal.`;
  }

  function setSummary(text) {
    if (summaryEl.textContent !== text) summaryEl.textContent = text;
  }

  function update() {
    save();
    const profile = getProfile();
    if (profile.error) {
      outputEl.innerHTML = '';
      setSummary(profile.error);
      return;
    }
    const analysis = analyze(profile);
    const logged = state.items.length > 0;
    const sections = [proteinPanel(profile, analysis), aminoPanel(profile, analysis)];
    if (logged) {
      sections.push(
        gapsPanel(analysis),
        planPanel(profile, analysis, buildPlan(profile, analysis)),
        foodsPanel(analysis),
        mealsPanel(profile, analysis),
        `<div class="cantein-aa__extras">${glycinePanel(analysis)}${canteinPanel(profile, analysis)}</div>`,
      );
    }
    outputEl.innerHTML = sections.join('');
    setSummary(summaryText(profile, analysis));
  }

  function estimateNavy() {
    const metric = state.units === 'metric';
    const female = state.sex === 'female';
    const toInches = (value) => (metric ? value / CM_PER_IN : value);
    const height = metric ? num(state.heightCm) / CM_PER_IN : num(state.heightFt) * 12 + (num(state.heightIn) || 0);
    const neck = toInches(num(state.neck));
    const waist = toInches(num(state.waist));
    const hip = toInches(num(state.hip));
    if (!(height > 0) || !(neck > 0) || !(waist > 0) || (female && !(hip > 0))) {
      return { message: female ? 'Enter height, neck, waist, and hips to estimate.' : 'Enter height, neck, and waist to estimate.' };
    }
    if (height < 48 || height > 96) return { message: 'Check your height.' };
    const span = female ? waist + hip - neck : waist - neck;
    if (span <= 0) return { message: 'Your waist should measure larger than your neck. Check your measurements.' };
    const bodyFat = female
      ? 163.205 * Math.log10(span) - 97.684 * Math.log10(height) - 78.387
      : 86.010 * Math.log10(span) - 70.041 * Math.log10(height) + 36.76;
    if (bodyFat < 3 || bodyFat > 60) return { message: 'That result is outside the method’s range. Re-measure and try again.' };
    const value = round(bodyFat, 1);
    const category = ACE[female ? 'female' : 'male'].find(([limit]) => value < limit)[1];
    return { value, message: `Estimated body fat: ${fmtNum(value, 1)}% (${category} range).` };
  }

  function updateNavy() {
    navyEstimate = estimateNavy();
    navyResultEl.textContent = navyEstimate.message;
    navyApplyEl.disabled = navyEstimate.value === undefined;
  }

  function convertUnits(next) {
    if (next === state.units) return;
    const toMetric = next === 'metric';
    const weight = num(state.weight);
    if (weight > 0) state.weight = String(round(toMetric ? weight * KG_PER_LB : weight / KG_PER_LB, 1));
    for (const field of LENGTH_FIELDS) {
      const value = num(state[field]);
      if (value > 0) state[field] = String(round(toMetric ? value * CM_PER_IN : value / CM_PER_IN, 1));
    }
    if (toMetric) {
      const inches = num(state.heightFt) * 12 + (num(state.heightIn) || 0);
      if (inches > 0) state.heightCm = String(Math.round(inches * CM_PER_IN));
    } else {
      const inches = num(state.heightCm) / CM_PER_IN;
      if (inches > 0) {
        let feet = Math.floor(inches / 12);
        let rest = Math.round(inches - feet * 12);
        if (rest === 12) {
          feet += 1;
          rest = 0;
        }
        state.heightFt = String(feet);
        state.heightIn = String(rest);
      }
    }
    state.units = next;
  }

  function writeForm() {
    for (const field of FIELDS) {
      const control = form.elements[field];
      if (control) control.value = state[field];
    }
  }

  function updateUnitsUI() {
    const metric = state.units === 'metric';
    app.querySelectorAll('[data-aa-unit="weight"]').forEach((el) => {
      el.textContent = metric ? 'kg' : 'lb';
    });
    app.querySelectorAll('[data-aa-unit="length"]').forEach((el) => {
      el.textContent = metric ? 'cm' : 'in';
    });
    $('[data-aa-height="imperial"]').hidden = metric;
    $('[data-aa-height="metric"]').hidden = !metric;
    for (const [name, value] of Object.entries(PLACEHOLDERS[state.units])) form.elements[name].placeholder = value;
  }

  function updateSexUI() {
    const female = state.sex === 'female';
    $('[data-aa-female-only]').hidden = !female;
    waistLabelEl.textContent = female ? 'Waist at narrowest point' : 'Waist at navel';
  }

  function updateMealName() {
    mealNameEl.textContent = MEALS[state.meal].toLowerCase();
  }

  function refreshAll() {
    writeForm();
    updateUnitsUI();
    updateSexUI();
    updateNavy();
    updateMealName();
    renderLog();
    update();
  }

  function onField(control) {
    const { name } = control;
    if (!FIELDS.includes(name)) return;
    if (control.type === 'radio' && !control.checked) return;
    if (name === 'units') {
      convertUnits(control.value);
      writeForm();
      updateUnitsUI();
      updateNavy();
      update();
      return;
    }
    state[name] = control.value;
    if (name === 'meal') {
      updateMealName();
      update();
      return;
    }
    if (name === 'sex') updateSexUI();
    if (NAVY_FIELDS.includes(name)) updateNavy();
    update();
  }

  function itemRow(item) {
    const tail = (name) => `<span class="cantein-aa__item-protein" data-item-protein></span>`
      + `<button type="button" class="cantein-aa__remove" data-remove aria-label="Remove ${esc(name)}">×</button>`;
    if (item.custom) {
      const name = item.name || 'Other food';
      const kinds = ['plant', 'mixed', 'animal']
        .map((kind) => `<option value="${kind}"${item.profile === kind ? ' selected' : ''}>g protein, ${kind}</option>`)
        .join('');
      return `<div class="cantein-aa__item" data-uid="${item.uid}">
        <span class="cantein-aa__item-name">${esc(name)}<small>Custom: enter grams of protein</small></span>
        <input type="number" inputmode="decimal" min="0" step="any" placeholder="0" value="${esc(item.protein)}" data-field="protein" aria-label="Grams of protein in ${esc(name)}">
        <select data-field="profile" aria-label="Protein source for ${esc(name)}">${kinds}</select>
        ${tail(name)}
      </div>`;
    }
    const food = FOOD[item.foodId];
    const units = food.s
      .map(([label, grams], i) => `<option value="${i}"${item.unit === i ? ' selected' : ''}>${esc(servingLabel(label, grams))}</option>`)
      .join('');
    return `<div class="cantein-aa__item" data-uid="${item.uid}">
      <span class="cantein-aa__item-name">${esc(food.n)}<small>${esc(food.g)}</small></span>
      <input type="number" inputmode="decimal" min="0" step="any" value="${esc(item.qty)}" data-field="qty" aria-label="Amount of ${esc(food.n)}">
      <select data-field="unit" aria-label="Unit for ${esc(food.n)}">${units}<option value="g"${item.unit === 'g' ? ' selected' : ''}>grams</option></select>
      ${tail(food.n)}
    </div>`;
  }

  function renderLog() {
    if (!state.items.length) {
      logEl.innerHTML = '<p class="cantein-aa__log-empty">No foods yet. Search above to add what you ate, or load a sample day.</p>';
      return;
    }
    logEl.innerHTML = Object.entries(MEALS).map(([key, label]) => {
      const items = state.items.filter((item) => item.meal === key);
      if (!items.length) return '';
      return `<div class="cantein-aa__meal">
        <div class="cantein-aa__meal-head"><strong>${label}</strong><span data-meal-total="${key}"></span></div>
        ${items.map(itemRow).join('')}
      </div>`;
    }).join('');
    updateLogNumbers();
  }

  function updateLogNumbers() {
    const totals = {};
    for (const item of state.items) {
      const { protein } = nutrients(item);
      totals[item.meal] = (totals[item.meal] || 0) + protein;
      const cell = logEl.querySelector(`[data-uid="${item.uid}"] [data-item-protein]`);
      if (cell) cell.innerHTML = `${fmtProtein(protein)} g<span class="visually-hidden"> protein</span>`;
    }
    logEl.querySelectorAll('[data-meal-total]').forEach((el) => {
      el.textContent = `${fmtProtein(totals[el.dataset.mealTotal] || 0)} g protein`;
    });
  }

  function findItem(el) {
    const row = el.closest('[data-uid]');
    return row ? [row, state.items.find((item) => item.uid === Number(row.dataset.uid))] : [];
  }

  function onLogEdit(event) {
    const [row, item] = findItem(event.target);
    const { field } = event.target.dataset;
    if (!item || !ITEM_FIELDS.includes(field)) return;
    if (field === 'unit') {
      const food = FOOD[item.foodId];
      const grams = itemGrams(item, food);
      item.unit = event.target.value === 'g' ? 'g' : Number(event.target.value);
      if (grams > 0) {
        item.qty = String(item.unit === 'g' ? Math.round(grams) : round(grams / food.s[item.unit][1], 2));
        row.querySelector('[data-field="qty"]').value = item.qty;
      }
    } else {
      item[field] = event.target.value;
    }
    updateLogNumbers();
    update();
  }

  function addFood(foodId, qty, unit = 0) {
    const food = FOOD[foodId];
    if (!food) return;
    state.items.push({ uid: nextUid++, foodId, qty: String(qty ?? food.q), unit, meal: state.meal });
    renderLog();
    update();
  }

  function addCustom(name) {
    const uid = nextUid++;
    state.items.push({
      uid, custom: true, name: name.slice(0, 60), protein: '', profile: state.diet === 'vegan' ? 'plant' : 'mixed', meal: state.meal,
    });
    renderLog();
    update();
    logEl.querySelector(`[data-uid="${uid}"] [data-field="protein"]`)?.focus();
  }

  const normalize = (text) => text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const SEARCH = FOODS.map((food) => ({
    food,
    name: normalize(food.n).split(' '),
    words: normalize(`${food.n} ${food.w || ''}`).split(' '),
    group: normalize(food.g).split(' '),
  }));

  function stems(term) {
    const forms = [term];
    if (term.length > 3 && term.endsWith('es')) forms.push(term.slice(0, -2));
    if (term.length > 3 && term.endsWith('s')) forms.push(term.slice(0, -1));
    return forms;
  }

  const UNIT_WORDS = {
    g: 'g', gram: 'g', grams: 'g', oz: 'oz', ounce: 'oz', ounces: 'oz', lb: 'lb', lbs: 'lb', pound: 'lb', pounds: 'lb', kg: 'kg',
    cup: 'cup', cups: 'cup', tbsp: 'tbsp', tablespoon: 'tbsp', tablespoons: 'tbsp', tsp: 'tsp', teaspoon: 'tsp', teaspoons: 'tsp',
    scoop: 'scoop', scoops: 'scoop', slice: 'slice', slices: 'slice', can: 'can', cans: 'can', container: 'container',
    containers: 'container', serving: 'serving', servings: 'serving', piece: 'piece', pieces: 'piece',
  };
  const GRAMS_PER_UNIT = { g: 1, oz: 28.349523125, lb: 453.59237, kg: 1000 };
  const NUMBER_WORDS = { a: 1, an: 1, one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, half: 0.5 };
  const FILLER_WORDS = new Set(['of', 'x', 'small', 'medium', 'large']);
  const MAX_SERVINGS = 12;

  function readNumber(token) {
    if (/^\d+(\.\d+)?$/.test(token)) return parseFloat(token);
    const fraction = /^(\d+)\/(\d+)$/.exec(token);
    return fraction && Number(fraction[2]) ? Number(fraction[1]) / Number(fraction[2]) : null;
  }

  // Splits "1 scoop cantein unflavored" or "chicken breast 150g" into search terms and an amount.
  function parseQuery(query) {
    const tokens = query.toLowerCase()
      .replace(/[¼½¾]/g, (char) => ` ${{ '¼': '1/4', '½': '1/2', '¾': '3/4' }[char]} `)
      .replace(/(\d),(\d)/g, '$1.$2')
      .replace(/(\d)([a-z])/g, '$1 $2')
      .split(/[\s,]+/)
      .filter(Boolean);
    let qty = null;
    let unit = null;
    let start = 0;
    let end = tokens.length;
    const lead = readNumber(tokens[0] || '');
    if (lead !== null || (NUMBER_WORDS[tokens[0]] && tokens.length > 1)) {
      qty = lead ?? NUMBER_WORDS[tokens[0]];
      start = 1;
      const part = lead !== null && Number.isInteger(lead) && /^\d+\/\d+$/.test(tokens[1] || '') ? readNumber(tokens[1]) : null;
      if (part !== null && part < 1) {
        qty += part;
        start = 2;
      }
      if (UNIT_WORDS[tokens[start]]) unit = UNIT_WORDS[tokens[start++]];
    } else if (end > 1) {
      const lastUnit = UNIT_WORDS[tokens[end - 1]];
      const trailing = readNumber(tokens[end - (lastUnit ? 2 : 1)] || '');
      if (trailing !== null && end > (lastUnit ? 2 : 1)) {
        qty = trailing;
        unit = lastUnit || null;
        end -= lastUnit ? 2 : 1;
      }
    }
    const terms = normalize(tokens.slice(start, end).join(' ')).split(' ')
      .filter((term) => term && !FILLER_WORDS.has(term) && !UNIT_WORDS[term] && !/^\d+$/.test(term));
    return { terms, qty, unit };
  }

  // The logged amount for a parsed quantity, or null to fall back to the food's default serving.
  function amountFor(food, { qty, unit }) {
    if (!(qty > 0)) return null;
    const find = (name) => food.s.findIndex(([label]) => label.split(/[\s,(]/)[0] === name);
    if (!unit || unit === 'serving' || unit === 'piece') {
      return qty <= MAX_SERVINGS ? { qty, unit: 0 } : { qty: round(qty, 1), unit: 'g' };
    }
    if (GRAMS_PER_UNIT[unit]) {
      const oz = find('oz');
      if (unit === 'oz' && oz >= 0) return { qty, unit: oz };
      if (unit === 'lb' && oz >= 0) return { qty: qty * 16, unit: oz };
      return { qty: round(qty * GRAMS_PER_UNIT[unit], 1), unit: 'g' };
    }
    const index = find(unit);
    if (index >= 0) return { qty, unit: index };
    const tbsp = find('tbsp');
    const cup = find('cup');
    if (unit === 'tsp' && tbsp >= 0) return { qty: round(qty / 3, 2), unit: tbsp };
    if (unit === 'tbsp' && cup >= 0) return { qty: round(qty / 16, 2), unit: cup };
    if (unit === 'cup' && tbsp >= 0) return { qty: qty * 16, unit: tbsp };
    return null;
  }

  function searchFoods(terms) {
    if (!terms.length) return [];
    const results = [];
    for (const entry of SEARCH) {
      let score = 0;
      let direct = true;
      for (const term of terms) {
        const forms = stems(term);
        const starts = (words) => words.some((word) => forms.some((form) => word.startsWith(form)));
        if (entry.words.includes(term)) score += 1;
        if (starts(entry.name)) score += 3;
        else if (starts(entry.words)) score += 2;
        else if (term.length > 2 && entry.words.some((word) => forms.some((form) => word.includes(form)))) score += 1;
        else if (starts(entry.group)) {
          score += 1;
          direct = false;
        } else {
          score = 0;
          break;
        }
      }
      if (!score) continue;
      if (entry.name.join(' ').startsWith(terms.join(' '))) score += 2;
      results.push({ food: entry.food, score, direct });
    }
    const matches = results.some((result) => result.direct) ? results.filter((result) => result.direct) : results;
    return matches
      .sort((a, b) => b.score - a.score || a.food.n.length - b.food.n.length)
      .slice(0, 8)
      .map((result) => result.food);
  }

  // Anonymous, personless PostHog events: no cookies, no stored ID, no location, and nothing from the profile or log.
  function track(event, properties) {
    if (!ANALYTICS_KEY) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) return;
    fetch(`${ANALYTICS_HOST}/i/v0/e/`, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        api_key: ANALYTICS_KEY,
        event,
        distinct_id: VISIT_ID,
        properties: {
          ...properties,
          $process_person_profile: false,
          $geoip_disable: true,
          $current_url: location.origin + location.pathname,
        },
      }),
    }).catch(() => {});
  }

  const trackedMisses = new Set();
  let missTimer = 0;

  function trackMiss(query, terms) {
    clearTimeout(missTimer);
    const term = terms.join(' ');
    if (term.length < 3 || trackedMisses.has(term)) return;
    missTimer = setTimeout(() => {
      trackedMisses.add(term);
      track('food_search_no_results', { search_term: term, query: query.slice(0, 80) });
    }, MISS_DELAY);
  }

  function openOptions() {
    const query = searchEl.value.trim();
    if (!query) {
      clearTimeout(missTimer);
      closeOptions();
      return;
    }
    const parsed = parseQuery(query);
    const foods = searchFoods(parsed.terms);
    if (foods.length) clearTimeout(missTimer);
    else trackMiss(query, parsed.terms);
    options = [...foods.map((food) => ({ food, amount: amountFor(food, parsed) })), { custom: query }];
    optionsEl.innerHTML = options.map((option, i) => {
      if (!option.food) {
        return `<li id="aa-option-${i}" role="option" aria-selected="false" data-index="${i}" class="cantein-aa__option-custom">`
          + `<strong>${foods.length ? 'Not listed?' : 'No match.'} Add “${esc(option.custom)}” by grams of protein</strong>`
          + '<small>Uses a typical plant, animal, or mixed amino acid profile</small></li>';
      }
      const { food, amount } = option;
      const [label, size] = food.s[0];
      const grams = amount ? itemGrams(amount, food) : size;
      const detail = amount ? amountLabel(food, amount) : `per ${servingLabel(label, size)}`;
      return `<li id="aa-option-${i}" role="option" aria-selected="false" data-index="${i}">`
        + `<strong>${esc(food.n)}</strong><small>${esc(food.g)} · ${esc(detail)}</small>`
        + `<span class="cantein-aa__option-meta">${fmtProtein((food.p * grams) / 100)} g protein</span></li>`;
    }).join('');
    optionsEl.hidden = false;
    searchEl.setAttribute('aria-expanded', 'true');
    setActive(foods.length ? 0 : -1);
  }

  function closeOptions() {
    optionsEl.hidden = true;
    searchEl.setAttribute('aria-expanded', 'false');
    searchEl.removeAttribute('aria-activedescendant');
    activeOption = -1;
  }

  function setActive(index) {
    activeOption = index;
    Array.from(optionsEl.children).forEach((el, i) => el.setAttribute('aria-selected', String(i === index)));
    const active = optionsEl.children[index];
    if (active) {
      searchEl.setAttribute('aria-activedescendant', active.id);
      active.scrollIntoView({ block: 'nearest' });
    } else {
      searchEl.removeAttribute('aria-activedescendant');
    }
  }

  function choose(index) {
    const option = options[index];
    if (!option) return;
    searchEl.value = '';
    closeOptions();
    if (option.food) {
      addFood(option.food.id, option.amount?.qty, option.amount?.unit ?? 0);
      searchEl.focus();
    } else {
      clearTimeout(missTimer);
      track('custom_food_added', {
        search_term: parseQuery(option.custom).terms.join(' '),
        query: option.custom.slice(0, 80),
        had_matches: options.length > 1,
      });
      addCustom(option.custom);
    }
  }

  function loadSample(name) {
    const sample = SAMPLES[name];
    if (!sample) return;
    if (getProfile().error) {
      const { weightLb, ...profile } = sample.profile;
      Object.assign(state, profile, {
        weight: String(state.units === 'metric' ? round(weightLb * KG_PER_LB, 1) : weightLb),
      });
    }
    state.diet = sample.diet;
    state.items = sample.items.map(([foodId, qty, meal]) => ({ uid: nextUid++, foodId, qty: String(qty), unit: 0, meal }));
    refreshAll();
  }

  form.addEventListener('input', (event) => {
    if (event.target.type !== 'radio') onField(event.target);
  });
  form.addEventListener('change', (event) => {
    if (event.target.type === 'radio') onField(event.target);
  });
  form.addEventListener('submit', (event) => event.preventDefault());

  navyApplyEl.addEventListener('click', () => {
    if (navyEstimate.value === undefined) return;
    state.bodyFat = String(navyEstimate.value);
    form.elements.bodyFat.value = state.bodyFat;
    navyResultEl.textContent = `Using ${fmtNum(navyEstimate.value, 1)}% body fat in your targets.`;
    update();
  });

  logEl.addEventListener('input', (event) => {
    if (event.target.tagName === 'INPUT') onLogEdit(event);
  });
  logEl.addEventListener('change', (event) => {
    if (event.target.tagName === 'SELECT') onLogEdit(event);
  });
  logEl.addEventListener('click', (event) => {
    const button = event.target.closest('[data-remove]');
    if (!button) return;
    const [, item] = findItem(button);
    state.items = state.items.filter((entry) => entry !== item);
    renderLog();
    update();
    searchEl.focus();
  });

  searchEl.addEventListener('input', openOptions);
  searchEl.addEventListener('focus', () => {
    if (searchEl.value.trim()) openOptions();
  });
  searchEl.addEventListener('blur', () => setTimeout(closeOptions, 120));
  searchEl.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (optionsEl.hidden) {
        openOptions();
        return;
      }
      const step = event.key === 'ArrowDown' ? 1 : -1;
      setActive((activeOption + step + options.length) % options.length);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      if (!optionsEl.hidden && options.length) choose(activeOption >= 0 ? activeOption : 0);
    } else if (event.key === 'Escape' && !optionsEl.hidden) {
      event.preventDefault();
      closeOptions();
    }
  });
  optionsEl.addEventListener('mousedown', (event) => event.preventDefault());
  optionsEl.addEventListener('click', (event) => {
    const option = event.target.closest('[role="option"]');
    if (option) choose(Number(option.dataset.index));
  });

  outputEl.addEventListener('click', (event) => {
    const button = event.target.closest('[data-add-food]');
    if (!button) return;
    const food = FOOD[button.dataset.addFood];
    const grams = Number(button.dataset.grams);
    if (food && grams > 0) addFood(food.id, round(grams / food.s[0][1], 2));
  });

  app.querySelectorAll('[data-aa-sample]').forEach((button) => {
    button.addEventListener('click', () => loadSample(button.dataset.aaSample));
  });
  $('[data-aa-reset]').addEventListener('click', () => {
    state = { ...DEFAULTS, units: state.units, items: [] };
    refreshAll();
  });

  refreshAll();
})();
